<template>
  <div>
    <Movementmenu_govem/>
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="ข้อมูลสรุปผลการประมวลผลการย้าย"
        class="px-5 py-3"
      >
        <div class="text-right mb-1">
          <v-btn text small color="primary" @click="pageGuideDialog = true">
            <v-icon left small>mdi-help-circle-outline</v-icon>วิธีใช้งานหน้านี้
          </v-btn>
        </div>

        <v-row dense class="mb-2">
          <v-col cols="6" sm="4" md="2">
            <v-card color="info" dark class="pa-3 text-center d-flex flex-column justify-center" height="90px">
              <div class="text-h4 font-weight-bold">{{ stats.total }}</div>
              <div style="font-size:13px;">รายการทั้งหมด</div>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-card color="info" dark class="pa-3 text-center d-flex flex-column justify-center" height="90px">
              <div class="text-h4 font-weight-bold">{{ stats.byType.teacher }}</div>
              <div style="font-size:13px;">ครูฯ</div>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-card color="primary" dark class="pa-3 text-center d-flex flex-column justify-center" height="90px">
              <div class="text-h4 font-weight-bold">{{ stats.byType.govem }}</div>
              <div style="font-size:13px;">พนักงานราชการ</div>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-card
              :color="stats.anomalyTotal > 0 ? 'error' : 'grey'"
              dark
              class="pa-3 text-center d-flex flex-column justify-center"
              height="90px"
              style="cursor:pointer"
              @click="showOnlyAnomalies = !showOnlyAnomalies"
            >
              <div class="text-h4 font-weight-bold">{{ stats.anomalyTotal }}</div>
              <div style="font-size:13px;">รายการผิดปกติ (คลิกกรอง)</div>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-card color="warning darken-2" dark class="pa-3 text-center d-flex flex-column justify-center" height="90px">
              <div class="text-h4 font-weight-bold">{{ stats.duplicatePosition }}</div>
              <div style="font-size:13px;">ตำแหน่งซ้ำ</div>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-card color="secondary" dark class="pa-3 text-center d-flex flex-column justify-center" height="90px">
              <div class="text-h4 font-weight-bold">{{ stats.duplicateCard }}</div>
              <div style="font-size:13px;">ผู้ขอย้ายซ้ำ</div>
            </v-card>
          </v-col>
        </v-row>

        <v-card class="mb-4 pa-2">
          <v-row no-gutters>
            <v-col cols="12" md="4" class="pa-1">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
                single-line
                hide-details
                dense
                filled
              />
            </v-col>
            <v-col cols="6" md="2" class="pa-1">
              <v-select
                v-model="times_select"
                :items="time_ss"
                item-value="time_ss"
                label="ครั้งที่ :"
              ></v-select>
            </v-col>
            <v-col cols="6" md="2" class="pa-1">
              <v-select
                v-model="years_select"
                :items="year_ss"
                item-value="year_ss"
                label="ปีที่ :"
              ></v-select>
            </v-col>
            <v-col cols="6" md="2" class="pa-1">
              <v-select
                v-model="statusFilter"
                :items="statusFilterOptions"
                item-text="text"
                item-value="value"
                label="กรองตามสถานะ"
                clearable
                dense
              ></v-select>
            </v-col>
            <v-col cols="6" md="2" class="pa-1">
              <v-btn color="info" large block @click="searchTimeYear()"
                >ค้นหา</v-btn
              >
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" class="pa-1">
              <v-switch
                v-model="showOnlyAnomalies"
                color="error"
                label="แสดงเฉพาะรายการผิดปกติ"
                hide-details
                dense
                inset
              ></v-switch>
            </v-col>
          </v-row>
        </v-card>
        <v-select
          v-model="selectedHeaders"
          :items="headers"
          label="เลือกคอลัมน์ที่ต้องการแสดง"
          multiple
          outlined
          return-object
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < 6">
              <span>{{ item.text }}</span>
            </v-chip>
            <span v-if="index === 6" class="grey--text caption"
              >(+{{ selectedHeaders.length - 6 }} คอลัมน์)</span
            >
          </template>
        </v-select>
        <v-data-table
          color="success"
          :headers="showHeaders"
          :items="filteredItems"
          :search="search"
          :loading="loading"
          :item-class="row_classes"
          disable-pagination
        >
          <template v-slot:item.anomaly="{ item }">
            <v-tooltip bottom v-if="anomalyReasons(item).length">
              <template v-slot:activator="{ on, attrs }">
                <v-chip color="error" dark small v-bind="attrs" v-on="on">
                  <v-icon left small>mdi-alert-circle</v-icon>{{ anomalyReasons(item).length }}
                </v-chip>
              </template>
              <div v-for="(reason, i) in anomalyReasons(item)" :key="i">{{ reason }}</div>
            </v-tooltip>
            <v-chip v-else color="success" outlined small>
              <v-icon left small>mdi-check-circle-outline</v-icon>ปกติ
            </v-chip>
          </template>

          <template v-slot:item.actionCencel="{ item }">
            <v-btn
              fab
              small
              v-if="item.ctsstatus_select === 'transfer'"
              @click="CencelMovementCut(item.ctsid_ref)"
              color="warning"
              ><v-icon>mdi-cancel</v-icon></v-btn
            >
            <v-btn
              fab
              small
              v-else
              @click="CencelMovement(item.ctsid_ref)"
              color="warning"
              ><v-icon>mdi-cancel</v-icon></v-btn
            >
          </template>

          <template v-slot:item.college_name_new="{ item }">
            <v-chip color="success darken-1" dark class="font-weight-bold" small>
              {{ item.college_name_new }}
            </v-chip>
          </template>

          <template v-slot:item.id_branch="{ item }">
            <div>
              <v-chip v-if="item.id_branch" color="success">
                <v-icon>mdi-checkbox-marked-circle</v-icon>
              </v-chip>
            </div>
          </template>

          <template v-slot:item.college_name_old="{ item }">
            <v-chip color="info darken-2" dark class="font-weight-bold" small>
              {{ item.college_name_old }}
            </v-chip>
          </template>

          <template v-slot:item.service_status="{ item }">
            <v-chip v-if="item.service_status === 'service'" color="warning">
              <span style="font-size:16px;"> <v-icon>mdi-check</v-icon></span>
            </v-chip>
          </template>

          <template v-slot:item.demand_college="{ item }">
            <v-chip v-if="item.ctsstatus_select === 'demand'" color="warning">
              <span style="font-size:16px;"> <v-icon>mdi-check</v-icon></span>
            </v-chip>
          </template>

          <template v-slot:item.ctsstatus_select="{ item }">
            <v-chip color="success" dark>
              <span
                style="font-size:16px;"
                v-if="item.ctsstatus_select === 'demand'"
              >
                ว.ประสงค์รับ</span
              >
              <span
                style="font-size:16px;"
                v-if="item.ctsstatus_select === 'agree'"
              >
                ปกติ</span
              >
              <span
                style="font-size:16px;"
                v-if="item.ctsstatus_select === 'transfer'"
              >
                ตัดโอน</span
              >
              <span
                style="font-size:16px;"
                v-if="item.ctsstatus_select === 'sw_normal'"
              >
                สับเปลี่ยน</span
              >
              <span
                style="font-size:16px;"
                v-if="item.ctsstatus_select === 'sw_agree'"
              >
                (แลกเปลี่ยน)</span
              >
            </v-chip>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
            >ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.</v-alert
          >
        </v-data-table>
      </base-material-card>

      <v-dialog v-model="pageGuideDialog" max-width="700">
        <v-card rounded="lg">
          <div class="guide-header">
            <v-icon size="32" color="white" class="mr-3">mdi-clipboard-list-outline</v-icon>
            <div>
              <h3 class="white--text mb-0">วิธีใช้งานหน้าข้อมูลสรุปผลการประมวลผลการย้าย</h3>
              <p class="white--text caption mb-0" style="opacity:.85">คำอธิบายการ์ดสถิติ การตรวจสอบรายการผิดปกติ และตัวกรอง</p>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="pageGuideDialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </div>

          <v-card-text class="pt-5" style="max-height: 70vh; overflow-y: auto;">
            <div class="text-subtitle-1 font-weight-bold mb-2">การ์ดสถิติ (แถวบนสุด)</div>
            <v-simple-table dense class="mb-4">
              <tbody>
                <tr><td width="180" class="font-weight-medium">รายการทั้งหมด</td><td>จำนวนรายการยืนยันการย้ายทั้งหมดในรอบที่กำลังแสดง</td></tr>
                <tr><td class="font-weight-medium">ครูฯ / พนักงานราชการ</td><td>แยกจำนวนตามประเภทบุคลากร (สังเกตจากรหัสอ้างอิงที่ขึ้นต้นด้วย "gov_" = พนักงานราชการ)</td></tr>
                <tr><td class="font-weight-medium">รายการผิดปกติ</td><td>จำนวนรายการที่ระบบตรวจพบความผิดปกติอย่างน้อย 1 ข้อ (คลิกการ์ดนี้เพื่อกรองแสดงเฉพาะรายการเหล่านี้)</td></tr>
                <tr><td class="font-weight-medium">ตำแหน่งซ้ำ / ผู้ขอย้ายซ้ำ</td><td>จำนวนรายการที่ตรวจพบการซ้ำซ้อนของตำแหน่งปลายทาง หรือของบุคคลเดียวกัน</td></tr>
              </tbody>
            </v-simple-table>

            <div class="text-subtitle-1 font-weight-bold mb-2">เกณฑ์ตรวจสอบรายการผิดปกติ</div>
            <v-simple-table dense class="mb-4">
              <tbody>
                <tr><td width="220" class="font-weight-medium">สถานะไม่ถูกต้อง/ไม่ได้ระบุ</td><td>รายการที่ไม่มีการระบุสถานะ หรือระบุค่าที่ระบบไม่รู้จัก — มักเกิดจากการบันทึกที่ไม่สมบูรณ์</td></tr>
                <tr><td class="font-weight-medium">ตำแหน่งปลายทางซ้ำ</td><td>มีรายการอื่นในรอบเดียวกันระบุตำแหน่ง+สถานศึกษาปลายทางเดียวกัน (อาจมีการจองตำแหน่งซ้ำ)</td></tr>
                <tr><td class="font-weight-medium">ผู้ขอย้ายซ้ำ</td><td>บุคคลเดียวกันมีมากกว่า 1 รายการยืนยันในรอบเดียวกัน</td></tr>
                <tr><td class="font-weight-medium">ต้นทาง-ปลายทางแห่งเดียวกัน</td><td>สถานศึกษาต้นทางและปลายทางเป็นแห่งเดียวกัน ซึ่งผิดปกติสำหรับการย้าย</td></tr>
                <tr><td class="font-weight-medium">ไม่พบชื่อ-สกุล</td><td>รหัสบัตรประชาชนในรายการนี้ไม่ตรงกับข้อมูลบุคลากรที่มีอยู่ในระบบ</td></tr>
              </tbody>
            </v-simple-table>

            <div class="text-subtitle-1 font-weight-bold mb-2">ตัวกรอง</div>
            <v-simple-table dense>
              <tbody>
                <tr><td width="180" class="font-weight-medium">ครั้งที่ / ปีที่</td><td>เลือกรอบการย้ายที่ต้องการดู แล้วกด "ค้นหา"</td></tr>
                <tr><td class="font-weight-medium">กรองตามสถานะ</td><td>แสดงเฉพาะรายการที่มีสถานะตรงกับที่เลือก (รวมตัวเลือก "ไม่ระบุ/ผิดปกติ")</td></tr>
                <tr><td class="font-weight-medium">แสดงเฉพาะรายการผิดปกติ</td><td>เปิดสวิตช์นี้เพื่อกรองเฉพาะรายการที่ตรวจพบความผิดปกติ (เทียบเท่าคลิกการ์ด "รายการผิดปกติ")</td></tr>
              </tbody>
            </v-simple-table>
          </v-card-text>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn color="primary" rounded @click="pageGuideDialog = false">เข้าใจแล้ว</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- V-model canceldialog -->
      <v-layout row justify-center>
        <v-dialog v-model="canceldialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="warning"
              icon="mdi-clipboard-text"
              title="ยกเลิกรายการ"
              class="px-5 py-3 text_google"
            >
              <div class="text-right"></div>
            </base-material-card>
            <v-card-text>
              <v-form ref="cancelform" lazy-validation>
                {{ conditons_transfer_successs.id_cts }}
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md6>
                      <p>
                        รหัสอ้างอิง :
                        {{ transference_personnels_id_ref.id_ref }}
                      </p>

                      <div class="text--center">
                        รหัสบัตรประชาชน :
                        {{ transference_personnels_id_ref.id_card }}
                        ชื่อ-นามสกุล :
                        {{ transference_personnels_id_ref.title_s
                        }}{{ transference_personnels_id_ref.frist_name }}
                        {{ transference_personnels_id_ref.last_name }}

                        สถานศึกษาปัจจุบัน :
                        {{ transference_personnels_id_ref.college_name }}
                        เลขที่ตำแหน่งปัจจุบัน :
                        {{ transference_personnels_id_ref.id_position }}
                      </div>
                    </v-flex>
                    <v-flex
                      md6
                      v-if="
                        conditons_transfer_successsSelect.ctsstatus_select ===
                          'transfer'
                      "
                    >
                      ตัดโอนตำแหน่ง ไปยัง :
                      {{ conditons_transfer_successsSelect.college_name_new }}
                    </v-flex>
                    <v-flex md6 v-else>
                      <p>
                        รหัสวิทยาลัยปลายทาง :
                        {{ conditons_transfer_successsSelect.ctscollege_code || "" }}
                      </p>
                      <div>
                        วิทยาลัย :
                        {{ conditons_transfer_successsSelect.college_name_new || "" }}
                      </div>
                      เลขที่ตำแหน่ง :
                      {{ conditons_transfer_successsSelect.ctsid_position || "" }}
                    </v-flex>
                    <v-flex xs12>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="canceldialog = false" rounded>
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>

              <v-btn
                v-if="
                  conditons_transfer_successsSelect.ctsstatus_select ===
                    'transfer'
                "
                large
                color="warning"
                @click.stop="cancelCutSubmit()"
                rounded
              >
                <v-icon dark>mdi-delete-forever</v-icon>&nbsp;ยืนยัน
              </v-btn>

              <v-btn
                v-else
                large
                color="warning"
                @click.stop="cancelSubmit()"
                rounded
              >
                <v-icon dark>mdi-delete-forever</v-icon>&nbsp;ยืนยัน
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>{{ snackbar.text }}</v-card-text>

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import Movementmenu_govem from '../../../components/admin/movementmenu_govem.vue';



export default {
  data() {
    return {
      i: 0,
      value: 6,
      loading: false,
      ApiKey: "HRvec2021",
      branch_s: [],
      tid_ref: [],
      valid: true,
      canceldialog: false,
      positiondialog: false,
      clear_dataDialog: false,
      times_select: "",
      years_select: "",
      type_name_position: "",
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      time_ss: [1, 2],
      year_ss: [2565, 2566, 2567, 2568, 2569, 2570],
      name_position_s: [
        { text: "สายการสอนและสนับสนุนการสอน", value: "ครู" },
        { text: "สายงานบริหารสถานศึกษา", value: "บริหาร" }
      ],
      conditons_transfer_successs: [],
      editconditons_transfer_success: {},
      search: "",
      pagination: {},
      singleSelect: false,
      selected: [],
      headers: [],
      selectedHeaders: [],
      headersMap: [
        { text: "ผิดปกติ", align: "center", value: "anomaly" },
        { text: "สถานะ", align: "left", value: "ctsstatus_select" },
        { text: "ยกลิก", align: "left", value: "actionCencel" },
        { text: "ครั้งที่", align: "left", value: "ctstime_s" },
        { text: "ปีที่", align: "center", value: "ctsyear_s" },
        { text: "สังกัดใหม่", align: "center", value: "college_name_new" },
        { text: "เลขที่", align: "center", value: "ctsid_position" },
        { text: "รหัสสาขา", align: "center", value: "ctsid_branch" },
        { text: "เงื่อนไข", align: "center", value: "branch_name" },
        { text: "ตรงเงื่อนไขวิทยาลัย", align: "center", value: "id_branch" },
        { text: "รหัสบัตรประชาชน", align: "center", value: "ctsid_card" },
        { text: "คำนำหน้าชื่อ", align: "center", value: "title_s" },
        { text: "ชื่อ", align: "center", value: "frist_name" },
        { text: "นามสกุล", align: "center", value: "last_name" },
        { text: "เลขที่", align: "left", value: "ctsid_postion_old" },
        { text: "สังกัดเดิม", align: "center", value: "college_name_old" },
        {
          text: "จำนวนผู้ขอย้ายรวม",
          align: "left",
          value: "personnel_num_all"
        },
        { text: "วุฒิตรง(อันดับ)", align: "left", value: "personnel_num_ed" },
        {
          text: "จำนวนผู้ขอย้ายในสาขาเดียวกัน",
          align: "left",
          value: "personnel_num_branch"
        },
        { text: "ลำดับที่ขอย้าย", align: "left", value: "tlsequence_n" },
        {
          text: "อายุราชการในสถานศึกษาปัจจุบัน",
          align: "left",
          value: "age_app_cal"
        },
        { text: "อายุราชการตั้งแต่บรรจุ", align: "left", value: "age_app" },
        { text: "ช่วยปฏิบัติราชการ", align: "left", value: "service_status" },
        {
          text: "วิทยาลัยประสงค์รับย้าย",
          align: "left",
          value: "demand_college"
        },
        { text: "สรุป", align: "left", value: "summary_s" },
        { text: "ขาด/เกินเกณฑ์", align: "left", value: "total_s" }
      ],
      rowsperpage: [
        25,
        50,
        100,
        {
          text: "All",
          value: -1
        }
      ],
      conditons_transfer_successs: [],
      periods: [],
      transference_personnels_id_ref: [],
      conditons_transfer_successsSelect: [],
      pageGuideDialog: false,
      showOnlyAnomalies: false,
      statusFilter: null,
      statusFilterOptions: [
        { text: "ว.ประสงค์รับ", value: "demand" },
        { text: "ปกติ", value: "agree" },
        { text: "ตัดโอน", value: "transfer" },
        { text: "สับเปลี่ยน", value: "sw_normal" },
        { text: "แลกเปลี่ยน", value: "sw_agree" },
        { text: "ไม่ระบุ/ผิดปกติ", value: "__invalid__" }
      ]
    };
  },
  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },
  async mounted() {
    await this.periodQuery();
    await this.conditons_transfer_successQueryAll();
  },
  methods: {
    async CencelMovementCut(id_ref) {
      let result_con = await this.$http.post("transference_personnel_govem.php", {
        ApiKey: this.ApiKey,
        id_ref: id_ref
      });
      this.transference_personnels_id_ref = result_con.data;

      let result_cts = await this.$http.post("conditons_transfer_success.php", {
        ApiKey: this.ApiKey,
        ctsid_ref: id_ref
      });
      this.conditons_transfer_successsSelect = result_cts.data;

      this.canceldialog = true;
    },
    async CencelMovement(id_ref) {
      let result_con = await this.$http.post("transference_personnel_govem.php", {
        ApiKey: this.ApiKey,
        id_ref: id_ref
      });
      this.transference_personnels_id_ref = result_con.data;
      let result_cts = await this.$http.post("conditons_transfer_success.php", {
        ApiKey: this.ApiKey,
        ctsid_ref: id_ref
      });

      this.conditons_transfer_successsSelect = result_cts.data;
      this.canceldialog = true;
    },
    async cancelCutSubmit() {
      if (this.$refs.cancelform.validate()) {
        this.conditons_transfer_successsSelect.ApiKey = this.ApiKey;
        let result_cts = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successsSelect
        );

        if (result_cts.data.status == true) {
          this.snackbar.icon = "mdi-font-awesome";
          this.snackbar.color = "success";
          this.snackbar.text = "ยกเลิกข้อมูลเรียบร้อย";
          this.snackbar.show = true;
          this.conditons_transfer_successQueryAll();
        } else {
          this.snackbar.icon = "mdi-close-network";
          this.snackbar.color = "red";
          this.snackbar.text = "ยกเลิกข้อมูลผิดพลาด";
          this.snackbar.show = true;
        }
        this.conditons_transfer_successQueryAll();
        this.canceldialog = false;
      }
    },
    async cancelSubmit() {
      if (!this.$refs.cancelform.validate()) return;
      this.loading = true;
      try {
        // เรียก endpoint ธุรกรรมเดียว (transaction) ที่สลับตำแหน่งใน government_employee
        // กลับคืน + ลบ conditons_transfer_success ในคำขอเดียว — แทนที่การเรียก
        // man_power.* (ตารางข้าราชการครู) หลายคำขอแยกกันแบบเดิมซึ่งเขียนผิดตาราง
        // และไม่มี transaction ครอบ (เสี่ยงข้อมูลเพี้ยนค้างถ้าขั้นกลางทางล้มเหลว)
        let result = await this.$http.post("transference_govem_position.cancel.php", {
          ApiKey: this.ApiKey,
          id_cts: this.conditons_transfer_successsSelect.id_cts
        });

        if (result.data.status == true) {
          this.snackbar.icon = "mdi-font-awesome";
          this.snackbar.color = "success";
          this.snackbar.text = "ยกเลิกข้อมูลเรียบร้อย";
          this.snackbar.show = true;
        } else {
          this.snackbar.icon = "mdi-close-network";
          this.snackbar.color = "red";
          this.snackbar.text = result.data.message || "ยกเลิกข้อมูลผิดพลาด";
          this.snackbar.show = true;
        }
      } catch (e) {
        this.snackbar.icon = "mdi-close-network";
        this.snackbar.color = "red";
        this.snackbar.text = "เกิดข้อผิดพลาดในการเชื่อมต่อ";
        this.snackbar.show = true;
      } finally {
        this.loading = false;
        this.conditons_transfer_successQueryAll();
        this.canceldialog = false;
      }
    },
    async periodQuery() {
      let result_period;
      result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "401"
      });
      this.periods = result_period.data;
    },
    async searchTimeYear() {
      this.loading = true;
      let result = await this.$http
        .post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctstime_s: this.times_select,
          ctsyear_s: this.years_select
        })
        .finally(() => (this.loading = false));
      this.conditons_transfer_successs = result.data;
    },
    async conditons_transfer_successQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctstime_s: this.periods.period_times,
          ctsyear_s: this.periods.period_year
        })
        .finally(() => (this.loading = false));
      this.conditons_transfer_successs = result.data;
    },
    async clear_data() {
      this.clear_dataDialog = true;
    },
    getColor(calories) {
      if (calories > 0) return "green";
      else return "";
    },
    // รวบรวมเหตุผลความผิดปกติของแถวนี้เป็นข้อความอ่านง่าย — ใช้ทั้งแสดง tooltip ในตาราง และ
    // นับสถิติรวมใน computed: stats ด้านล่าง (เกณฑ์ตรงกับฟิลด์ที่ conditons_transfer_success.php
    // คำนวณมาให้แล้ว: is_status_invalid, duplicate_position_count, duplicate_card_count, is_same_college)
    anomalyReasons(item) {
      const reasons = [];
      if (item.is_status_invalid == 1 || !item.ctsstatus_select) {
        reasons.push("สถานะไม่ถูกต้องหรือไม่ได้ระบุ");
      }
      if (item.duplicate_position_count > 0) {
        reasons.push(`ตำแหน่งปลายทางซ้ำกับอีก ${item.duplicate_position_count} รายการในรอบเดียวกัน`);
      }
      if (item.duplicate_card_count > 0) {
        reasons.push(`ผู้ขอย้ายรายนี้มีรายการซ้ำอีก ${item.duplicate_card_count} รายการในรอบเดียวกัน`);
      }
      if (item.is_same_college == 1) {
        reasons.push("สถานศึกษาต้นทางและปลายทางเป็นแห่งเดียวกัน");
      }
      if (!item.frist_name && !item.last_name) {
        reasons.push("ไม่พบชื่อ-สกุลผู้ขอย้ายในระบบบุคลากร");
      }
      return reasons;
    },
    row_classes(item) {
      if (this.anomalyReasons(item).length > 0) {
        return "red lighten-4";
      }
      if (item.ctsstatus_select == "transfer") {
        return "grey";
      }
    }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    color() {
      return "green darken-4";
    },
    date_today_cal() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();
      today = yyyy + "-" + mm + "-" + dd;
      return today;
    },
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    },
    filteredItems() {
      let items = this.conditons_transfer_successs || [];
      if (this.showOnlyAnomalies) {
        items = items.filter(item => this.anomalyReasons(item).length > 0);
      }
      if (this.statusFilter === "__invalid__") {
        items = items.filter(item => item.is_status_invalid == 1 || !item.ctsstatus_select);
      } else if (this.statusFilter) {
        items = items.filter(item => item.ctsstatus_select === this.statusFilter);
      }
      return items;
    },
    stats() {
      const items = this.conditons_transfer_successs || [];
      const stats = {
        total: items.length,
        byType: { teacher: 0, govem: 0 },
        anomalyTotal: 0,
        duplicatePosition: 0,
        duplicateCard: 0
      };
      items.forEach(item => {
        if (String(item.ctsid_ref || "").startsWith("gov_")) {
          stats.byType.govem++;
        } else {
          stats.byType.teacher++;
        }
        if (this.anomalyReasons(item).length > 0) stats.anomalyTotal++;
        if (item.duplicate_position_count > 0) stats.duplicatePosition++;
        if (item.duplicate_card_count > 0) stats.duplicateCard++;
      });
      return stats;
    }
  },
  components: { Movementmenu_govem }
};
</script>

<style scoped>
.orange {
  background-color: rgb(236, 194, 115);
}

.guide-header {
  background: linear-gradient(135deg, #455a64 0%, #455a64 100%);
  padding: 20px 24px;
  display: flex;
  align-items: center;
}
</style>
